import { useState } from 'react';
import { Link } from 'react-router-dom';

import {
  DeleteFilled,
  EditFilled,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';

import { Button, Input, Table, Form, Tooltip } from 'antd';

import { RoleHeader as columns } from '@/utils/tableHeader';
import '@/assets/style/modern-group-list.css';

//  api
import { roleApiEndpoints } from '@/api/endpoints';
import { handleDeleteApi } from '@/api/crud';
import { useFetch } from '@/hooks';

import { globalSearch } from '@/utils/search/Search';
import GlobalModal from '@/utils/modal/Modal';

import { enablePaginationOrNot } from '@/utils/common';

/**
 * roles list component
 * @returns
 */
const Roles = () => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [referenceId, setReferenceId] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const [form] = Form.useForm();

  const { data, isLoading, refresh } = useFetch(roleApiEndpoints.retrieveList);

  const handleCancel = () => {
    setOpenDeleteModal(false);
    form.resetFields();
    setReferenceId(null);
  };

  const handleOpenDeleteModal = (id) => {
    setReferenceId(id);
    setOpenDeleteModal(true);
  };

  const handleDeleteOk = () => {
    setOpenDeleteModal(false);
    handleDeleteApi(referenceId, roleApiEndpoints.delete, setLoading, refresh);
  };

  return (
    <>
      {/*  branch crud modals */}
      {/* delete  modal */}

      <GlobalModal
        isVisible={openDeleteModal}
        onConfirm={handleDeleteOk}
        onClose={handleCancel}
        type="delete"
      />

      <div className="modern-group-page">
        <div className="modern-group-header-row">
          <div className="modern-group-header">
            <h1 className="modern-group-title">Roles</h1>
            <p className="modern-group-subtitle">
              Manage and organize your roles
            </p>
          </div>
          <div className="modern-group-actions">
            <Input
              className="header-search"
              name="query"
              value={searchQuery}
              onChange={(event) => setSearchQuery(event.target.value)}
              placeholder="Search Role..."
              prefix={<SearchOutlined />}
              style={{ width: '300px' }}
            />
            <Link to="/role/create/" className="tw-w-fit">
              <Button type="primary" className="centered">
                <PlusOutlined />
                Create
              </Button>
            </Link>
          </div>
        </div>

        <div className="table-responsive modern-table-wrapper">
          <Table
            size="large"
            bordered
            loading={isLoading || loading}
            columns={columns?.map((col) => ({
              ...col,
              onCell: () => ({
                style: {
                  padding: '6px 12px',
                },
              }),
            }))}
            className="ant-border-space"
            style={{ textAlign: 'center' }}
            scroll={{ x: true, y: 'calc(100vh - 220px)' }}
            pagination={!isLoading ? enablePaginationOrNot(data) : false}
            dataSource={globalSearch(data, searchQuery)?.map((role, index) => {
              return {
                key: role.referenceId,
                index: index + 1,
                name: role.roleType,
                companyName: role.companyName,
                branchName: role.branchName,
                action: (
                  <div className="ant-action tw-flex tw-gap-4 tw-justify-center tw-align-center">
                    <Tooltip title="Edit">
                      <Link
                        to={`/role/${role.referenceId}/edit/`}
                        className="edit tw-inline-flex tw-cursor-pointer hover:tw-bg-blue-200 tw-rounded-full tw-p-1"
                      >
                        <EditFilled className="tw-text-blue-600" />
                      </Link>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <span
                        className="text-danger tw-inline-flex tw-cursor-pointer hover:tw-bg-red-200 tw-rounded-full tw-p-1"
                        onClick={() => handleOpenDeleteModal(role.referenceId)}
                      >
                        <DeleteFilled />
                      </span>
                    </Tooltip>
                  </div>
                ),
              };
            })}
          />
        </div>
      </div>
    </>
  );
};

export default Roles;
